/**
 * Sentences every send on the Emails page shares, so a test, a result
 * and a count read the same way whichever email is being sent.
 */

/** A send to everyone that the backend skipped because no email account
 *  is connected. */
export const EMAIL_OFF_SENTENCE =
  "Email sending isn't switched on yet, so nothing was sent.";

/** A send that never reached the server. */
export const SEND_OFFLINE_SENTENCE =
  "That didn't send. Check your internet connection and try again.";

/** "1 person" / "14 people". */
export function people(count: number): string {
  return `${count} ${count === 1 ? "person" : "people"}`;
}

/** "1 booking" / "14 bookings". */
export function bookings(count: number): string {
  return `${count} ${count === 1 ? "booking" : "bookings"}`;
}

/** What a send to everyone reports back. */
interface SendAllResult {
  recipients: number;
  sent: number;
  failed: number;
  skipped: number;
}

/**
 * "Sent to 14 people." or "Sent to 12 of 14 people. 2 didn't go through."
 * `nobodySentence` covers a send that found no one to email.
 */
export function sendAllSentence(
  result: SendAllResult,
  nobodySentence: string,
): string {
  if (result.recipients === 0) {
    return nobodySentence;
  }
  if (result.skipped === result.recipients) {
    return EMAIL_OFF_SENTENCE;
  }
  const sentences = [
    result.sent === result.recipients
      ? `Sent to ${people(result.sent)}.`
      : `Sent to ${result.sent} of ${people(result.recipients)}.`,
  ];
  if (result.failed > 0) {
    sentences.push(`${result.failed} didn't go through.`);
  }
  if (result.skipped > 0) {
    sentences.push(
      `${result.skipped} ${result.skipped === 1 ? "was" : "were"} skipped.`,
    );
  }
  return sentences.join(" ");
}

/** The plain test confirmation: "Test sent to you@example.com. Open it
 *  and check it looks right." */
export function testSentSentence(sentTo: string | readonly string[]): string {
  const list = Array.isArray(sentTo) ? sentTo.join(", ") : sentTo;
  return `Test sent to ${list}. Open it and check it looks right.`;
}
